module.exports = __webpack_public_path__ + "static/media/amazonuk-button.edf370cc.png";